"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    externalFilename: zod_1.z.string().describe('External filename'),
    loanProductSlug: zod_1.z.string().describe('Loan product slug'),
    creditFacilitySlug: zod_1.z.string().nullable().describe('Credit facility slug'),
    encryptionConfig: finley_types_1.Util.EncryptionConfigSchema.optional().describe('Encryption config'),
    outputFileExtension: finley_types_1.Util.SupportedFileExtensionSchema.optional().describe('Explicit output file extension'),
    uploadConfig: tape_builder_base_1.RawUploadConfigSchema.optional().describe('Optional configuration for uploading a file on BBPL monitor.'),
});
exports.nodeType = 'file_rawRepaymentTape';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    externalFilename: true,
    creditFacilitySlug: true,
    loanProductSlug: true,
});
exports.artifactType = 'rawRepaymentTape';
//# sourceMappingURL=types.js.map